module.exports = __webpack_public_path__ + "img/Frame_s15_b0_9x9_1_STT_UK.2eaf8b8c.png";